varying vec3 vPosition;
uniform vec3 uOuterColor;
uniform vec3 uInnerColor;

void main() {
	float dist = length(vPosition.xy);
	gl_FragColor = vec4( mix(uInnerColor, uOuterColor, dist*dist), 1. );
}
